import { TAsset } from 'src/typings/configuration.types';
import { TConfigurationState } from 'src/redux/configuration/configuration.slice';

export function getCommunityAsset({
  assets,
  rootAssetUuid,
  assetsTreeRelations,
}: Pick<TConfigurationState, 'assets' | 'rootAssetUuid' | 'assetsTreeRelations'>):
  | TAsset
  | undefined {
  if (!rootAssetUuid) return;

  const rootChildrenAssets = assetsTreeRelations[rootAssetUuid].map((uuid) => assets[uuid]);
  const communityAsset = rootChildrenAssets.find((asset) => asset.type === 'Area');

  return communityAsset;
}
